import React, { Component } from 'react';
import '../../styles/css/DashboardComponents/JobStats.css';

class JobStatistics extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        const { jobData } = this.props;

        return (
            <div className="headerCardRoot">
                <div className="adminHeaderCardMain fixedStatsHeight">
                    <div className="userHeaderCardTitle">
                        <span>Job statistics</span>
                    </div>
                    <div className="adminHeaderCardBody ">
                        <div className="totalJobStats">
                            <div className="statRow highlighted">
                                <span>Total jobs</span>
                                <span className="">{jobData.all}</span>
                            </div>
                            <div className="statRow">
                                <span>Created</span>
                                <span className="">{jobData.created}</span>
                            </div>
                            <div className="statRow">
                                <span>Posted</span>
                                <span className="">{jobData.posted}</span>
                            </div>
                            <div className="statRow">
                                <span>Expired</span>
                                <span className="">{jobData.expired}</span>
                            </div>
                            <div className="statRow">
                                <span>In progress</span>
                                <span className="">{jobData.inprogress}</span>
                            </div>
                            <div className="statRow">
                                <span>Verify</span>
                                <span className="">{jobData.verify}</span>
                            </div>
                            <div className="statRow">
                                <span>Completed</span>
                                <span className="">{jobData.completed}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default JobStatistics;


// WEBPACK FOOTER //
// ./src/components/DashboardComponents/JobStats.js